import React, { useContext, useEffect, useRef, useState } from 'react'
import { Box, Grid, Snackbar, Typography } from '@material-ui/core'
import HeadTile from './HeadTile'
import Toggle from './Toggle';
import { db, functions } from '../../../../config/firebase';
import { UserContext } from '../../../../context/UserProvider';
import { Alert } from '@material-ui/lab';
import { DashboardContext } from '../../../../context/DashboardProvider';
import { current } from '@reduxjs/toolkit';
const sendMqttMsgToLoraWan = functions.httpsCallable("sendMqttMsgToLoraWan");

export const LoraWanControllerTile = ({ data, style, col }) => {
	const { usuario  } = useContext(UserContext);
	const { setOpenLwToggleAlert, lwToggleAlertData,setLwToggleAlertData } = useContext(DashboardContext)
	const uid = data.uid;
	const deviceId = uid.split("@")[2]
	const outId = uid.split("@")[4]
	const [controllerName, setControllerName] = useState("-")
	const [togglePosition, setTogglePosition] = useState("0")
	const [statusLabelColor, setStatusLabelColor] = useState("text.disabled")
	const [openAlert, setOpenAlert] = useState(false);
	const [configSnackbar, setConfigSnackbar] = useState({
		severity: "info",
		msg: "Enviando comando"
	})
	const [controllerIdName, setControllerIdName] = useState("")
	const [isConfirmationAwaited, setIsConfirmationAwaited] = useState(false);

	const handleToggleChange = (event) => {
		setTogglePosition(event.value)
		if (event.value === "1") {
			setStatusLabelColor("success.main")
		} else {
			setStatusLabelColor("text.disabled")
		}
		sendMqttMsgToLoraWan({
			name: controllerIdName,
			deviceId: deviceId,
			command: "output",
			outId: Number(outId),
			stateToggle: Number(event.value)
		})
		setOpenAlert(true)
		setOpenLwToggleAlert(true)
		setIsConfirmationAwaited(true)
	}

	const handleCloseAlert = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
	  
		setOpenAlert(false)
	}

	const isMountedRef = useRef(null);

	useEffect(() => {
		isMountedRef.current = true; // Indicar que el componente está montado
		const getConfigController= async () => {
			try {
				const addr = `${usuario.username}/loraDevices/nodes/${deviceId}/namesOfCards`;
				const addr2 = `${usuario.username}/loraDevices/nodes/${deviceId}/controllers`;
				const docRef = db.collection(addr).doc("names");
				const docRef2 = db.collection(addr2).doc("registeredControllers");
				const docSnap = await docRef.get();
				const docSnap2 = await docRef2.get();
				if (docSnap.exists) {
					const allSensorNames = docSnap.data().allNames;
					const controllerId = uid.split("@")[3];
					const outId = uid.split("@")[4]
					const nameId = `${controllerId}-${outId}`
					const idFounded = allSensorNames.find(item => item.id === nameId);
					const nameFounded = idFounded ? idFounded.name : "Toggle-LW";
					if(docSnap2.exists) {
						const allControllers = docSnap2.data().allControllers;
						const controllerFounded = allControllers.find(
							(item) => item.id === controllerId
						)
						if(controllerFounded) {
							setControllerIdName(controllerFounded.nameId)
						} else { setControllerIdName(nameFounded)}
					} else { setControllerIdName(nameFounded) }
					setControllerName(nameFounded)

				} else {
					setControllerName("Toggle-LW")
				}
			} catch (error) {
				console.error("Error en obtener datos del toggle:",error)
				setControllerName("Toggle-LW")
			}
		};
		getConfigController();
		return () => {
			isMountedRef.current = false; // Indicar que el componente se ha desmontado
		};
	  
	}, [deviceId,uid,usuario.username])

	useEffect(() => {
		const baseAddr = `${usuario.username}/loraDevices/nodes/${deviceId}/controllers/controllersInfo`
		const posAddr = `${baseAddr}/togglesData`
		const responseAddr = `${baseAddr}/gatewayResponse`

		const idController = uid.split("@")[3]
		const outid = uid.split("@")[4]
		const docId = `${idController}-${outid}`
		const docRef = db.collection(responseAddr).doc(docId);
		const docRef2 = db.collection(posAddr).doc(docId);
		
	
		// onSnapshot escucha en tiempo real los cambios del documento
		const unsubscribe = docRef.onSnapshot(async (docSnapshot) => {
			if(docSnapshot.exists){
				const responseData = docSnapshot.data();
				console.log("Esto es responseData de gatewayResponse:",responseData)
				const idReceived = responseData.controllerId;
				const outReceived = responseData.outId;
				const statusResponse = responseData.status;
				if (responseData && idReceived === idController && outReceived === outid && statusResponse === "OK" && isConfirmationAwaited) {
					console.log("Entre a la condicion if1")
					if (responseData.position === togglePosition) {
						console.log("Esto es togglePosition:",togglePosition)
						console.log("Entre a la condicion if2")
						setLwToggleAlertData({type: "success", msg: "Configuración exitosa"})
						setConfigSnackbar({severity: "success", msg: "Configuración exitosa"})
						const allDataToggle = await docRef2.get()
						if(allDataToggle.exists) {
							const dataToggle = allDataToggle.data()
							const newDate = new Date();
							const updateToggleData = {
								id: dataToggle.id,
								lastUpdate: newDate.toISOString(),
								outId: dataToggle.outId,
								position: togglePosition
							}
							
							await docRef2.set({ ...updateToggleData });
						}
						setOpenAlert(true)

					} else {
						setLwToggleAlertData({type: "success", msg: "Configuración exitosa"})
					}
					await docRef.update({
						status: "-",
					}).then(() => {
						setIsConfirmationAwaited(false)
					}).catch((error) => {
						console.error("Error al actualizar el documento LwController:", error);
					});
				}
			} else {
				console.log("No se encontro documento")
			}
		},
		(error) => {
		  console.error("Error en onSnapshot LWController:", error);
		}
		);
		
		// La función de limpieza se ejecuta cuando el componente se desmonta
		return () => unsubscribe();
	}, [usuario.username,deviceId,uid,isConfirmationAwaited,togglePosition]);

	useEffect(() => {
	  	if(lwToggleAlertData.type === "success" || lwToggleAlertData.type === "error" || configSnackbar.severity === "success") {
			const timer = setTimeout(() => {
				setOpenLwToggleAlert(false)
				setLwToggleAlertData({type: "info", msg: "Enviando comando"})
			}, 5000);
		
			// Función de limpieza para evitar que el timeout se ejecute si el componente se desmonta
			return () => clearTimeout(timer);
	  	}
	}, [lwToggleAlertData,configSnackbar])

	useEffect(() => {
		const idController = uid.split("@")[3]
		const outid = uid.split("@")[4]
		const docId = `${idController}-${outid}`
		const responseAddr = `${usuario.username}/loraDevices/nodes/${deviceId}/controllers/controllersInfo/togglesData`
		const docRef = db.collection(responseAddr).doc(docId)
	
		// onSnapshot escucha en tiempo real los cambios del documento
		const unsubscribe = docRef.onSnapshot((docSnapshot) => {
			if(docSnapshot.exists){
				const currentPosition = docSnapshot.data().position;
				setTogglePosition(currentPosition)
				if (currentPosition === "1") {
					setStatusLabelColor("success.main")
				} else {
					setStatusLabelColor("text.disabled")
				}
				console.log("Esto es responseData de controllersInfo:",currentPosition)
				// const controllerId = uid.split("@")[3];
				// const controllerOutId = uid.split("@")[4];
				// const toggleId = `${controllerId}-${controllerOutId}`
				// for (let index = 0; index < responseData.length; index++) {
				// 	const element = responseData[index];
				// 	if(element.id === toggleId) {
				// 		setTogglePosition(element.position)
				// 		if (element.position === "1") {
				// 			setStatusLabelColor("success.main")
				// 		} else {
				// 			setStatusLabelColor("text.disabled")
				// 		}
						
						
				// 	}
				// }

			} else {
				console.log("No se encontro documento")
			}
		},
		(error) => {
		  console.error("Error en onSnapshot LWController:", error);
		}
		);
		
		// La función de limpieza se ejecuta cuando el componente se desmonta
		return () => unsubscribe();
	}, [usuario.username,deviceId,uid]);
	

	

  return (
	<Grid
	container
	direction="row"
	justifyContent="center"
	alignItems="flex-start"
	style={style}
	>
		<HeadTile name={controllerName} uid={uid} col={col} />

		<Grid item xs={10} />

		<Grid item xs={2}>
			{/* {console.log("Esto es state=== ON:",state===ON)}
			{console.log('Esto es state:', state)} */}
			<Typography component="div" variant="body1">
				<Box
				//color={(state === ON && posicion !== "0") ? "success.main" : "text.disabled"}
				color={statusLabelColor}
				fontWeight="fontWeightBold"
				>
				ON        
				{/* {console.log('Esto es state:', state)}
				{console.log('Esto es stateString:', stateString)} */}
				</Box>
			</Typography>
		</Grid>

		<Grid item xs={12}>
			<Toggle
				handleToggle={handleToggleChange}
				id={uid}
				posicion={togglePosition}
				disabled={col === 0 ? true : false}
			/>
			
		</Grid>

		{/* <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleCloseAlert}>
			<Alert onClose={handleCloseAlert} severity={configSnackbar.severity}>
				{configSnackbar.msg}
			</Alert>
		</Snackbar> */}

	</Grid>
  )
}
